import { useToast } from '@ui';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { errorMessage } from '../../../lib/errors';
import { usePhoto } from '../api';

/**
 * A hidden file (or camera) input that uploads the chosen photo. `open()`
 * can be called from any trigger, e.g. a menu item.
 */
export function usePhotoPicker(kind: 'colonies' | 'locations' | 'colony-notes', id: string) {
  const { t } = useTranslation();
  const toast = useToast();
  const ref = useRef<HTMLInputElement>(null);
  const upload = usePhoto(kind);
  const input = (
    <input
      ref={ref}
      type="file"
      accept="image/jpeg,image/png,image/webp,image/gif"
      hidden
      onChange={(e) => {
        const file = e.target.files?.[0];
        e.target.value = '';
        if (!file) return;
        upload.mutate(
          { id, file },
          {
            onSuccess: () => toast.show(t('apiary.photo.saved')),
            onError: (err) => toast.show(errorMessage(err), 'danger'),
          },
        );
      }}
    />
  );
  return { input, open: () => ref.current?.click(), pending: upload.isPending };
}
